module.exports = "https://web-assets.ifttt.com/packs/media/docs/connect_url_screenshot-aa9435f2.png";